import { render } from "./PinSvg.vue?vue&type=template&id=705d4128"
import script from "./PinSvg.vue?vue&type=script&lang=js"
export * from "./PinSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__